export enum HistoricalDataPeriodInterval {
    FIVE_SECONDS = '0',
    MINUTELY = '1',
    HOURLY = '60',
    DAILY = '1440',
}

export interface MarketForecastHistoryVo {
    event_ticker: string;
    market_ticker: string;
    raw_numerical_forecast: number;
    numerical_forecast: number;
    formatted_forecast: string;
    end_period_ts: number;
    period_interval: HistoricalDataPeriodInterval;
}

export interface HistoricalForecasts {
    eventTicker: string;
    marketTicker: string;
    rawNumericalForecast: number;
    numericalForecast: number;
    formattedForecast: string;
    ts: number;
    periodInterval: HistoricalDataPeriodInterval;
}

export interface GetMarketHistoricalDataRequest {
    start_ts: number;
    end_ts: number;
    period_interval: HistoricalDataPeriodInterval;
    candlestick_function?: string;
}

export interface GetForecastResponse {
    forecast_history: MarketForecastHistoryVo[];
}

export interface OHLC {
    open: number;
    high: number;
    low: number;
    close: number;
}
export interface CandlestickWithMean extends OHLC {
    mean: number;
    previous?: number;
}

export interface HistoricalMarketCandlestickStats {
    yesAsk: CandlestickWithMean;
    yesBid: CandlestickWithMean;
    price: CandlestickWithMean;
    volume: number;
    openInterest: number;
    startTs: number;
    ts: number; // The end timestamp. Named `ts` for consistency with HistoricalMarketStats.
}

export type MarketStatsType = 'stats' | 'candlesticks';

export interface MarketCandlestickVo {
    yes_ask: CandlestickWithMean;
    yes_bid: CandlestickWithMean;
    price: CandlestickWithMean;
    volume: number;
    open_interest: number;
    /** /v1 candlesticks count both sides, unlike the one-sided market summary fields. */
    volume_fp?: string;
    open_interest_fp?: string;
    end_period_ts: number;
}
